<content-loader viewBox="0 0 400 80" width="{400}">
  <svg:rect x="0" y="29" rx="4" ry="4" width="100" height="8" />
  <svg:rect x="130" y="29" rx="4" ry="4" width="100" height="8" />
  <svg:rect x="260" y="29" rx="4" ry="4" width="100" height="8" />

  <svg:rect x="0" y="45" rx="4" ry="4" width="100" height="8" />
  <svg:rect x="130" y="45" rx="4" ry="4" width="100" height="8" />
  <svg:rect x="260" y="45" rx="4" ry="4" width="100" height="8" />

  <svg:rect x="0" y="60" rx="4" ry="4" width="100" height="8" />
  <svg:rect x="130" y="60" rx="4" ry="4" width="100" height="8" />
  <svg:rect x="260" y="60" rx="4" ry="4" width="100" height="8" />
</content-loader>

<content-loader height="200" width="500" viewBox="0 0 265 80">
  <svg:rect x="0" y="5" rx="2" ry="2" width="350" height="90" />
</content-loader>
